import React from 'react';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const RestaurantDetail = lazyLoad(
  () => import('./detailPage'),
  module => module.RestaurantDetailPage,
  { fallback: <LoadingContainer loading /> },
);
